import Client from "../provider/provider";
import abi from "../abi/abi";
import contract from "../contract/contract";
import { ethers } from "ethers";

const claimRewards = function(mnemonic) {
return new Promise((resolve, reject) => {
	Client(mnemonic).then(wallet => {
		const contract_call = new ethers.Contract(contract.airdrop_addr, abi.abiAirdrop, wallet);
		
				contract_call.getRewards(contract.erc20_addr, contract.lock_reward_old_addr).then(tx=>{
					console.log(tx);
					resolve(tx.hash);
				}).catch(e =>{
				reject(e);
			});			
	
	});
});
}

export default claimRewards